import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {first} from 'rxjs/operators';
import {Result} from "@domain/common/http/result";
import {environment} from "@environments/environment";

/**
 * Service de gestion de la personnalisation des paramètres
 */
@Injectable({
    providedIn: 'root'
})
export class ParametrePersonnalisationService {
    /**
     * Constructeur
     * 
     * @param http Client HTTP
     */
    constructor(private http: HttpClient) {
    }
    
    /**
     * Récupère les informations des logos
     * 
     * @returns Observable contenant les informations des logos
     */
    getLogo(): Observable<Result> {
        return this.http.get<Result>(`${environment.baseUrl}/controller/LogoEntreprise/getInfosLogosEntreprise`)
            .pipe(first());
    }

    /**
     * Sauvegarde les paramètres de personnalisation des logos
     * 
     * @param formData FormData contenant les paramètres et fichiers à sauvegarder
     * @returns Observable contenant le résultat de la sauvegarde
     */
    saveLogo(formData: FormData): Observable<Result<void>> {
        return this.http.post<Result<void>>(
            `${environment.baseUrl}/controller/Entreprise/saveInfosLogosEntreprise`, 
            formData
        ).pipe(first());
    }
}
